import {
  CompanyAttributes,
  DocumentClassAttributes,
  MaterialStockAttributes,
  OrderAttributes,
  OrderDetailAttributes,
  OrderExtraStatusAttributes,
  WarehouseAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import { OrderStatusERPEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/order-status-erp.enum";
import SalesOfficeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity";
import { SelectionModel } from "@angular/cdk/collections";
import { CommonModule, DecimalPipe } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatBadgeModule } from "@angular/material/badge";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatOptionModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import {
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ActivatedRoute, Router } from "@angular/router";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { ReprintButtonComponent } from 'app/modules/shared/reprint-button/reprint-button.component';
import { NgSelectModule } from "@ng-select/ng-select";
import { FilterSectionComponent } from "app/common/components/filter-section/filter-section.component";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { DocumentTypeEnum } from "app/common/enums/document-types.enum";
import {
  IPaginationResultFrequencies,
  IRequestResult,
} from "app/common/interfaces";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import {
  ExportDialogComponent,
  ExportOptions,
} from "app/layout/export-overlay";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { BatchesDetailComponent } from "app/modules/shared/batches-detail/batches-detail.component";
import { DocumentFlowButtonComponent } from "app/modules/shared/document-flow-button/document-flow-button.component";
import { LogModalComponent } from "app/modules/shared/log-modal/log-modal.component";
import { CompanyCurrencyPipe } from "app/pipes/currency.pipe";
import { DecimalFormatPipe } from "app/pipes/decimal-company.pipe";
import { BusinessPartnerDisplayComponent } from "app/shared/components/business-partner-display/business-partner-display.component";
import { UserRouteDisplayComponent } from "app/shared/components/user-route-display/user-route-display.component";
import { ManualLabelSelectionIndicatorComponent } from "app/shared/components/manual-label-selection-indicator";
import { DateHelper } from "app/utils/date.helper";
import {
  validateIsAction,
  validateOrdersByAction,
} from "app/utils/document-class-validation";
import { getCode } from "app/utils/method";
import { environment } from "environments/environment.prod";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import {
  BehaviorSubject,
  debounceTime,
  distinctUntilChanged,
  skip,
  Subject,
  Subscription,
  take,
  takeUntil,
} from "rxjs";
import { CompanyService } from "../../configuration/company/company.service.service";
import { SalesOfficeService } from "../../configuration/sales-office/sales-office.service";
import { WarehouseService } from "../../configuration/warehouse/warehouse.service";
import { DocumentClassService } from "../../document/document-class/document-class.service";
import { BusinessPartnersFiltersComponent } from "../../filters/business-partners-filters/business-partners-filters.component";
import { ConfigurationFiltersComponent } from "../../filters/configuration-filters/configuration-filters.component";
import { DatesFiltersComponent } from "../../filters/dates-filters/dates-filters.component";
import { DocumentsFiltersComponent } from "../../filters/documents-filters/documents-filters.component";
import { IFilters } from "../../filters/interfaces/filterInterface";
import { MaterialsManagementFiltersComponent } from "../../filters/materials-management-filters/materials-management-filters.component";
import { RoutesFiltersComponent } from "../../filters/routes-filters/routes-filters.component";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { ImageCarouselComponent } from "../../reports/visits/visit-report/modal-image/modal-image.component";
import { FormApproRejectComponent } from "../../shared/form-appro-reject/form-appro-reject.component";
import { TypeRejectEnum } from "../../shared/form-appro-reject/type-document.enum";
import { AddOrderDetailComponent } from "../add-order-detail/add-order-detail.component";
import { CancelOrderComponent } from "../cancel-order/cancel-order.component";
import { FormRejectComponent } from "../form-reject/form-reject.component";
import { ModalApprovalUserComponent } from "../modal-approval-user/modal-approval-user.component";
import { MasterUserInterface } from "../order-generate/interfaces/master-user.interface";
import { OrdersCreationService } from "../order-generate/order-generate.service";
import { OrdersListService } from "../order-list-components/order-list.service";
import { SALES_RETURN_LIST_TITLE } from "../quotation/exports/quotation-list.constants";
import { SalesReturnListExport } from "../return-list/exports/return-list.export";
import { SelectOrderDetailComponent } from "../select-order-detail/select-order-detail.component";
import { IUpdateOrder } from "../update-order/interfaces/update-order.interface";
import { UpdateOrderComponent } from "../update-order/update-order.component";
import { UpdateOrderService } from "../update-order/update-order.service";
import { UnitMeasureDisplayComponent } from "../../../../shared/components/unit-measure-display/unit-measure-display.component";
import { AuditLogViewerService } from "app/shared/services/audit-log-viewer.service";
import { AUDIT_LOG_COLLECTIONS } from "app/shared/components/audit-log-viewer/audit-log-collections.constants";
import { HasPermissionPipe, PermissionDirective, PermissionService } from "app/core/permission";
import { HandlerMessageService } from "app/common/services/handler-error/handler-message.service";
import { SALES_DOCUMENT_PERMISSIONS } from "app/common/constants/permission";

@Component({
  selector: "app-request-return-list",
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIconModule,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatSidenavContainer,
    MatCheckboxModule,
    MatMenuModule,
    NgSelectModule,
    MatDatepickerModule,
    FormsModule,
    MatBadgeModule,
    NgxMatSelectSearchModule,
    MatAutocompleteModule,
    FilterComponent,
    DocumentFlowButtonComponent,
    DecimalFormatPipe,
    StatusFiltersComponent,
    DatesFiltersComponent,
    FilterSectionComponent,
    ConfigurationFiltersComponent,
    DocumentsFiltersComponent,
    RoutesFiltersComponent,
    BusinessPartnersFiltersComponent,
    MaterialsManagementFiltersComponent,
    UserRouteDisplayComponent,
    ManualLabelSelectionIndicatorComponent,
    BusinessPartnerDisplayComponent,
    HoverMenuDirective,
    CompanyCurrencyPipe,
    ReprintButtonComponent,
    UnitMeasureDisplayComponent,
    PermissionDirective,
    HasPermissionPipe,
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    DecimalPipe,
    SalesReturnListExport,
  ],
  templateUrl: "./request-return-list.component.html",
  styleUrl: "./request-return-list.component.scss",
})
export class RequestReturnListComponent implements OnInit, OnDestroy {
  readonly PERMISSIONS = SALES_DOCUMENT_PERMISSIONS.RETURN_REQUESTS;

  getCode = getCode;
  private isInitialized = false;
  projectName = environment.projectName;
  StatusEnum = StatusEnum;
  OrderStatusERPEnum = OrderStatusERPEnum;
  DocumentTypeEnum = DocumentTypeEnum;
  type = DocumentTypeEnum.SOLICITUD_DEVOLUCION_PRODUCTO; //Devolucion,

  displayedColumns: string[] = [
    "det",
    "check",
    "status",
    "statusERP",
    "type",
    "trip",
    // "subRoute",
    // "user",
    // "seller",
    "info",
    "businessPartner",
    "documentNumber",
    "class",
    //'date',
    "approvalUserLogins",
    //'subTotal', //'surcharge', 'discount', 'tax',
    "total",
    "creation",
    // 'documentStatus',
    "actions",
  ];
  dataSource = new MatTableDataSource<OrderAttributes>([]);

  totalItems: number = 0;
  searchControl = new FormControl("");
  search: string = "";
  pageSize: number = 50;
  pageIndex: number = 1;
  sortActive: keyof OrderAttributes = "createdAt";
  sortDirection: "asc" | "desc" = "desc";

  selection = new SelectionModel<any>(true, []);
  selectedOrder: OrderAttributes | null = null;

  //DETAIL
  displayedColumnsDetail: string[] = [
    "statusId",
    "evidence",
    "note",
    "material",
    //'warehouse',
    "soldQuantity",
    "unitPrice",
    "subTotal",
    //'totalSurcharges', 'totalDiscounts', 'tax',
    "total",
    "actionsAR",
    "actions",
  ];
  dataSourceDetail = new MatTableDataSource<OrderDetailAttributes>([]);

  companyList: CompanyAttributes[] = [];
  UMPActive: boolean;

  //Filter
  selectedStartDate: Date;
  selectedEndDate: Date;
  dateRange: FormGroup;

  //selectedStatusERP: number = 0;
  // Selección múltiple
  selectedStatusERP: number[] = [];

  //Para filtros
  selectedStatuses: number[] = [];

  // Estados ERP
  selectedERPStatuses: number[] = [];

  selectedCustomerType: string[] = [];
  // Controlador de búsqueda
  statusFilterCtrl = new FormControl();

  // Estados filtrados
  filteredStatusERP: BehaviorSubject<any[]> = new BehaviorSubject([]);

  // Estados de selección
  isStatusIndeterminate = false;
  isStatusChecked = false;

  private _onDestroy = new Subject<void>();

  //selectedDocumentClass: string = '0';
  selectedDocumentClass: string[] = [];
  filteredDocumentClasses: Subject<DocumentClassAttributes[]> = new Subject();
  documentClassMultiFilterCtrl: FormControl = new FormControl();
  isIndeterminateDocumentClass: boolean = false;
  isCheckedDocumentClass: boolean = false;
  private _onDestroyDocumentClass = new Subject<void>();

  selectedSeller: string = "0";
  selectedWithTravel: string = "0";

  documentClassesList: DocumentClassAttributes[] = [];
  sellerList: MasterUserInterface[] = [];

  isGlobalSynchronizeAvailable: boolean = false;
  hasUnsavedBatchChanges = false; // Flag para control global
  detailsWithUnsavedChanges = new Set<number>();

  orderStatusErpList = [
    { id: null, name: "Todos" },
    { id: 0, name: "Devolución pendiente" },
    { id: 4, name: "Error enviando a ERP" },
    { id: 1, name: "Devolución enviado a ERP" },
    { id: 2, name: "Devolución recibido por ERP" },
    { id: 3, name: "Devolución creado en ERP" },
  ];

  isOrderListTrip = environment.isOrderListTrip;
  isErpIntegrated = environment.isErpIntegrated;

  @ViewChild("orderDetailUpdateConfirmationDialog")
  orderDetailUpdateConfirmationDialog!: TemplateRef<any>;
  @ViewChild("orderDetailConfirmDialog")
  orderDetailConfirmDialog!: TemplateRef<any>;

  interval;
  timeInterval = 60000 * 15;
  showInterval: boolean = false;

  selectedSoldTo: string = "0";
  soldToControl = new FormControl("");
  soldToList: any[] = [];
  soldToFilterSelected: any = null;

  selectedShipTo: string = "0";
  shipToControl = new FormControl("");
  shipToList: any[] = [];

  //BUSCADOR
  searchSubscription: Subscription;
  subs: Subscription[] = [];
  ordersToFilter: string[] = [];

  form: FormGroup;

  loadConfigData = false;
  loadDocumentsData = false;
  loadRoutesData = false;
  loadBusinessPartnersData = false;
  loadMaterialsData = false;

  constructor(
    private readonly ordersListService: OrdersListService,
    private readonly updateOrderService: UpdateOrderService,
    private readonly ordersCreationService: OrdersCreationService,
    private readonly salesOfficeService: SalesOfficeService,
    private readonly warehouseService: WarehouseService,
    private readonly documentClassService: DocumentClassService,
    private readonly companyService: CompanyService,
    private readonly searchService: SearchService,
    private readonly snackBar: MatSnackBar,
    private readonly router: Router,
    private readonly dialog: MatDialog,
    private readonly cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private readonly salesReturnListExport: SalesReturnListExport,
    private readonly auditLogViewerService: AuditLogViewerService,
    private readonly permissionService: PermissionService,
    private readonly handlerMessage: HandlerMessageService
  ) {
    const today = new Date();
    this.dateRange = this.fb.group({
      start: [today],
      end: [today],
    });
    this.selectedStartDate = today;
    this.selectedEndDate = today;
    // this.selectedStartDate.setHours(0, 0, 0, 0);
    this.selectedEndDate.setHours(23, 59, 59, 999);

    this.form = this.fb.group({
      start: [today],
      end: [today],
      startTrip: [],
      endTrip: [],
      companyId: [],
      salesOfficeId: [],
      documentClassId: [],
      subRouteId: [],
      assignedUserId: [],
      payingBusinessPartnerId: [],
      receivingBusinessPartnerId: [],
      warehouseId: [],
      end_startTrip: [],
      end_endTrip: [],
      soldToControl: [],
      searchReceivingBusinessPartner: [],
      searchAssignedUser: [],
      materialGroupId: [[]],
      materialId: [],
    });
  }

  onConfigExpanded(): void {
    this.loadConfigData = true;
  }

  onDocumentsExpanded(): void {
    this.loadDocumentsData = true;
  }

  onRoutesExpanded(): void {
    this.loadRoutesData = true;
  }

  onBusinessPartnersExpanded(): void {
    this.loadBusinessPartnersData = true;
  }

  onMaterialsExpanded(): void {
    this.loadMaterialsData = true;
  }

  ngOnInit(): void {
    this.subs.push(
      this.activatedRoute.queryParams.pipe(take(1)).subscribe((params) => {
        if (params["orderIds"]) {
          this.ordersToFilter = params["orderIds"]
            ? params["orderIds"].split(",")
            : [];
        }
      })
    );
    this.onHandleSearch();
    this.onFilter();
    this.fetchCompanies();
    this.fetchDocumentClass();
    // this.getListSeller();
    // this.getListSoldTo(null);
    // this.getListShipTo(null);
    this.isInitialized = true;
  }

  ngAfterViewInit(): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS.VIEW, "No tiene permisos para ver esta pantalla.")) {
      return;
    }

    this.documentClassMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroyDocumentClass))
      .subscribe(() => {
        this.filterDocumentClasses();
        this.setToggleAllCheckboxStateDocumentClass();
      });

    this.searchControl.valueChanges
      .pipe(skip(1), debounceTime(500), distinctUntilChanged())
      .subscribe((filterValue: string) => {
        if (this.isInitialized) {
          this.pageIndex = 1;
          this.search = filterValue;
          this.getList();
        }
      });

    this.filteredStatusERP.next(this.orderStatusErpList);
    this.statusFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterStatusERP();
      });

    this.soldToControl.valueChanges
      .pipe(skip(1), debounceTime(500), distinctUntilChanged())
      .subscribe((value) => {
        if (this.isInitialized) {
          if (
            typeof value === "string" &&
            value.trim().length === 24 &&
            /^[a-f0-9]{24}$/.test(value)
          ) {
            return;
          }
          this.soldToList = [];
          this.soldToFilterSelected = null;
          this.getListSoldTo(value);

          this.getList();
        }
      });

    this.shipToControl.valueChanges
      .pipe(skip(1), debounceTime(500), distinctUntilChanged())
      .subscribe((value) => {
        if (this.isInitialized) {
          if (
            typeof value === "string" &&
            value.trim().length === 24 &&
            /^[a-f0-9]{24}$/.test(value)
          ) {
            return;
          }

          this.shipToList = [];
          this.getListShipTo(value);
          this.getList();
        }
      });
  }

  private filterDocumentClasses(): void {
    if (!this.documentClassesList) {
      return;
    }
    let search = this.documentClassMultiFilterCtrl.value;
    if (!search) {
      this.filteredDocumentClasses.next(this.documentClassesList);
      return;
    } else {
      search = search.toLowerCase();
    }
    const filtered = this.documentClassesList.filter((docClass) =>
      docClass.name.toLowerCase().includes(search)
    );
    this.filteredDocumentClasses.next(filtered);
  }

  onDocumentClassSelectionChange(selectedValues: string[]): void {
    this.selectedDocumentClass = selectedValues;
  }

  private setToggleAllCheckboxStateDocumentClass(): void {
    const selectedCount = this.selectedDocumentClass.length;
    const totalCount = this.documentClassesList.length;

    this.isCheckedDocumentClass =
      selectedCount > 0 && selectedCount === totalCount;
    this.isIndeterminateDocumentClass =
      selectedCount > 0 && selectedCount < totalCount;
  }

  filterStatusERP(): void {
    const search = this.statusFilterCtrl.value?.toLowerCase() || "";
    const filtered = this.orderStatusErpList.filter((os) =>
      os.name.toLowerCase().includes(search)
    );
    this.filteredStatusERP.next(filtered);
  }

  onStatusSelectionChange(selected: number[]): void {
    this.selectedStatusERP = selected;
    this.updateStatusSelectionState();
  }

  toggleSelectAllStatuses(isChecked: boolean): void {
    this.selectedStatusERP = isChecked
      ? this.orderStatusErpList.map((os) => os.id)
      : [];
    this.updateStatusSelectionState();
  }

  updateStatusSelectionState(): void {
    const total = this.orderStatusErpList.length;
    const selected = this.selectedStatusERP.length;
    this.isStatusChecked = total > 0 && selected === total;
    this.isStatusIndeterminate = selected > 0 && selected < total;
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1;
    this.search = filterValue;
    this.getList();
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$
      .pipe(skip(1), debounceTime(300))
      .subscribe((term) => {
        if (this.isInitialized) {
          this.applyFilter(term);
        }
      });
  }

  openInterval(event) {
    if (!this.checkIfHasPermission(this.PERMISSIONS.UPDATE_TIME, "No tiene permisos para modificar el tiempo.")) {
      return;
    }

    //para el html si se quiere activar o no
    if (!event) {
      this.showInterval = false;
    } else {
      this.showInterval = true;
    }
    this.onFilter();
  }

  onFilter() {
    if (this.showInterval) {
      if (this.interval) {
        clearInterval(this.interval);
      }
      this.getList();

      this.interval = setInterval(() => {
        this.getList();
      }, this.timeInterval);
    } else {
      this.getList();
    }
  }

  getList() {
    this.synchronizeDates();
    this.isGlobalSynchronizeAvailable = false;
    this.resetSelection();

    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" =
      this.sortDirection === "asc" ? "ASC" : "DESC";

    let options = {
      currentPage: this.pageIndex,
      limitPerPage: this.pageSize,
      search: this.search,
      sort: sortField,
      sortDirection: sortDirection,
    };

    const hasOrderIds = this.ordersToFilter && this.ordersToFilter.length > 0;
    const hasSearch = this.search && this.search.trim().length > 0;

    let dataFilter: IFilters = {
      type: this.type,
      startDate:
        hasOrderIds && !hasSearch
          ? null
          : this.form.get("start")?.value
            ? DateHelper.getStartOfDay(this.form.get("start")?.value)
            : null,
      endDate:
        hasOrderIds && !hasSearch
          ? null
          : this.form.get("end")?.value
            ? DateHelper.getEndOfDay(this.form.get("end")?.value)
            : this.form.get("start")?.value
              ? DateHelper.getEndOfDay(this.form.get("start")?.value)
              : null,
      startTrip: this.form.get("startTrip")?.value
        ? DateHelper.getStartOfDay(this.form.get("startTrip")?.value)
        : null,
      endTrip: this.form.get("endTrip")?.value
        ? DateHelper.getEndOfDay(this.form.get("endTrip")?.value)
        : this.form.get("startTrip")?.value
          ? DateHelper.getEndOfDay(this.form.get("startTrip")?.value)
          : null,
      end_startTrip: this.form.get("end_startTrip")?.value
        ? DateHelper.getStartOfDay(this.form.get("end_startTrip")?.value)
        : null,
      end_endTrip: this.form.get("end_endTrip")?.value
        ? DateHelper.getEndOfDay(this.form.get("end_endTrip")?.value)
        : this.form.get("end_startTrip")?.value
          ? DateHelper.getEndOfDay(this.form.get("end_startTrip")?.value)
          : null,
      companyId: this.form.get("companyId")?.value,
      salesOfficeId: this.form.get("salesOfficeId")?.value,
      warehouseId: this.form.get("warehouseId")?.value, //
      documentClass: this.form.get("documentClassId")?.value,
      subRouteId: this.form.get("subRouteId")?.value, //
      soldTo: this.form.get("payingBusinessPartnerId")?.value,
      shipTo: this.form.get("receivingBusinessPartnerId")?.value,
      seller: this.form.get("assignedUserId")?.value,
      withTravel: this.selectedWithTravel,
      status:
        hasOrderIds && !hasSearch
          ? null
          : this.selectedStatuses
            ? this.selectedStatuses
            : null,
      statusERP:
        hasOrderIds && !hasSearch
          ? null
          : this.selectedERPStatuses.length
            ? this.selectedERPStatuses
            : null,
      typeCustomer: this.selectedCustomerType.length
        ? this.selectedCustomerType
        : null,
      materialGroupId: this.form.get("materialGroupId").value,
      materialId: this.form.get("materialId").value,
      ordersToFilter: hasOrderIds ? this.ordersToFilter : null,
    };

    this.ordersListService.findAllWithCount(options, dataFilter).subscribe({
      next: (res: IPaginationResultFrequencies<OrderAttributes>) => {
        this.dataSource.data = res?.data?.data ?? [];
        this.totalItems = res?.data?.pageInfo?.[0]?.total ?? 0;

        if (hasOrderIds) {
          this.ordersToFilter = [];
        }
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message ||
            "Error al obtener la información de los pedidos.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  private getSortField(): keyof OrderAttributes {
    const sortFieldMapping: Record<string, keyof OrderAttributes> = {
      status: "statusERP",
      type: "type",
      trip: <any>"trip.id",
      subRoute: <any>"subRoute.name",
      user: <any>"user.user_login.username",
      soldTo: <any>"soldTo.name",
      documentNumber: "serial",
      class: <any>"class.name",
      date: "deliveryDateTime",
      creation: "creationDateTime",
    };
    return sortFieldMapping[this.sortActive] || "creationDateTime";
  }

  changeSort(e) {
    this.sortActive = e.active;
    this.sortDirection = e.direction;
    this.getList();
  }

  changePage(e: PageEvent) {
    this.pageIndex = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.getList();
  }

  isAllSelected() {
    const validRows = this.dataSource.data.filter((row) =>
      this.validateDataToSynchronize(row)
    );

    const numSelected = this.selection.selected.length;
    const numValidRows = validRows.length;
    return numSelected == numValidRows && numValidRows > 0;
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => {
          if (this.validateDataToSynchronize(row)) this.selection.select(row);
        });
  }

  resetSelection() {
    this.selection.clear();
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "select" : "deselect"} all`;
    }
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${row.position + 1}`;
  }

  onCheckboxChange(event, element?): void {
    let auxSelected = this.selection.selected;
    this.isGlobalSynchronizeAvailable =
      auxSelected.length > 0 &&
      auxSelected.filter((os) => !this.validateDataToSynchronize(os)).length ==
        0;
  }

  async toggleDetails(order: OrderAttributes): Promise<void> {
    if (this.selectedOrder && this.selectedOrder._id === order._id) {
      this.closeDetails();
      return;
    }

    this.selectedOrder = order;
    this.dataSourceDetail.data = this.selectedOrder.detail || [];

    // Obtiene almacenes y clase de documento
    const orderStatusId = this.selectedOrder.statusId;
    if (
      orderStatusId != StatusEnum.INACTIVE &&
      orderStatusId != StatusEnum.ORDER_APPROVED &&
      orderStatusId != StatusEnum.ORDER_REJECTED
    ) {
      if (!this.selectedOrder["warehousesToUpdate"]) {
        const salesOffice: Partial<SalesOfficeAttributes> =
          await this.salesOfficeService
            .findOne(this.selectedOrder.salesOffice._id.toString())
            .toPromise()
            .then((res) => res.data);
        if (salesOffice && salesOffice.warehouses) {
          let filter = {
            officeWarehouse: salesOffice.warehouses.map((ware) => ware._id),
            company: [environment.companyId],
          };
          this.selectedOrder["warehousesToUpdate"] = await this.warehouseService
            .filterComboBox(filter)
            .toPromise()
            .then((res) => res.data);
          this.getStock(
            this.selectedOrder,
            this.selectedOrder["warehousesToUpdate"]
          );
        }
      }

      this.getDocumentClass(this.selectedOrder);
    }
  }

  closeDetails(): void {
    this.selectedOrder = null;
  }

  formatDate(date: string | Date, includeTime?: boolean): string {
    if (date) {
      const d = new Date(date);
      const day = d.getDate().toString().padStart(2, "0");
      const month = (d.getMonth() + 1).toString().padStart(2, "0");
      const year = d.getFullYear();

      if (includeTime) {
        const hours = d.getHours().toString().padStart(2, "0");
        const minutes = d.getMinutes().toString().padStart(2, "0");
        const seconds = d.getSeconds().toString().padStart(2, "0");
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      }
      return `${day}-${month}-${year}`;
    }
    return "--:--:--";
  }

  formatHour(date: string): string {
    if (date) {
      const d = new Date(date);
      const hours = d.getHours().toString().padStart(2, "0");
      const minutes = d.getMinutes().toString().padStart(2, "0");
      const seconds = d.getSeconds().toString().padStart(2, "0");
      return `${hours}:${minutes}:${seconds}`;
    }
    return "--:--:--";
  }

  private fetchCompanies(): void {
    this.companyService.findToComboBox().subscribe((res) => {
      this.companyList = res.data;
      if (res.data.length === 1) {
        this.UMPActive = res.data[0].UMPActive;
      }
    });
  }

  onCompanySelectionChange(companyid: string): void {
    /*if (this.currentUpdateWarehouse) {
      this.currentUpdateWarehouse.company = this.companyList.find(
        (price) => price._id.toString() === companyid
      )!;
    }*/
  }

  clearFilters(): void {
    /*this.selectedCompanyIds = [];
    this.searchQuery = "";
    this.findAllWithCount();*/
    const today = new Date();
    this.dateRange.reset({ start: today, end: today });
    this.selectedStartDate = null;
    this.selectedEndDate = null;
    this.selectedDocumentClass = [];
    this.selectedStatusERP = [];
    this.selectedSeller = "0";
    this.soldToControl.setValue("");
    this.shipToControl.setValue("");
    this.soldToFilterSelected = null;
  }

  synchronizeDates(): void {
    this.selectedStartDate = this.dateRange.get("start")?.value;
    this.selectedEndDate = this.dateRange.get("end")?.value;
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  private fetchDocumentClass(): void {
    let dataToFilter = {
      type: this.type,
    };
    this.ordersListService
      .fetchDocumentClasses(dataToFilter)
      .subscribe((res) => {
        this.documentClassesList = res.data;
        this.filteredDocumentClasses.next(this.documentClassesList);
      });
  }

  private getListSeller() {
    this.ordersListService.fetchMasterUsers().subscribe({
      next: (res: IRequestResult<MasterUserInterface[]>) => {
        if (res.status == "success") {
          this.sellerList = res.data;
        }
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener vendedores.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  getListSoldTo(search?): void {
    let dataToSend = {
      companyIds: [environment.companyId],
      search: search?.toString() || "",
    };
    this.ordersListService.fetchSoldTos(dataToSend).subscribe((res) => {
      this.soldToList = res?.data;
      this.cdr.detectChanges();
    });
  }

  onChangeSoldTo() {
    this.soldToFilterSelected = this.soldToList.find(
      (stl) => stl.id == this.soldToControl.value
    );
    this.shipToControl.setValue("");
    this.getListShipTo();
  }

  getListShipTo(search?): void {
    this.shipToList = [];
    const soldToValue = this.soldToFilterSelected
      ? this.soldToFilterSelected._id
      : null;

    let dataToSend: any = {
      companyIds: [environment.companyId],
      search: search?.toString() || "",
    };

    if (soldToValue) {
      dataToSend.soldToMongoId = soldToValue;
    }

    this.ordersListService.fetchShipTos(dataToSend).subscribe((res) => {
      this.shipToList = res?.data;
      this.cdr.detectChanges();
    });
  }

  synchronizeOrders(order: OrderAttributes) {
    if (!this.checkIfHasPermission(this.PERMISSIONS.SYNC, "No tiene permisos para sincronizar solicitudes de devolución.")) {
      return;
    }

    environment.isSyncIntegratorAllowed
      ? this.synchronizeIntegrator(order)
      : this.synchronizeNormal(order);
  }

  synchronizeNormal(order: OrderAttributes) {
    let dataToSendPost = {
      TripIds: [],
      orderIds: [],
      method: "POST",
    };

    let dataToSendPut = {
      TripIds: [],
      orderIds: [],
      method: "PUT",
    };

    if (order) {
      if (order?.externalKeys?.code) {
        dataToSendPut.orderIds.push(order._id.toString());
      } else {
        dataToSendPost.orderIds.push(order._id.toString());
      }
    } else {
      this.selection.selected.forEach((o) => {
        if (o.externalKeys?.code) {
          dataToSendPut.orderIds.push(o._id.toString());
        } else {
          dataToSendPost.orderIds.push(o._id.toString());
        }
      });
    }

    const requests = [];
    if (dataToSendPost.orderIds.length > 0) {
      requests.push(
        this.ordersListService.synchronizeOrders(dataToSendPost).toPromise()
      );
    }
    if (dataToSendPut.orderIds.length > 0) {
      requests.push(
        this.ordersListService.synchronizeOrders(dataToSendPut).toPromise()
      );
    }

    if (requests.length === 0) {
      this.snackBar.open(
        "No se encontraron registros pendientes de sincronizar con ERP.",
        "Cerrar",
        { duration: 5000 }
      );
    }

    Promise.all(requests)
      .then(() => {
        this.snackBar.open("Registro sincronizado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.getList();
      })
      .catch((err) => {
        this.snackBar.open(
          err.error.message || "Error al sincronizar con el ERP.",
          "Cerrar",
          { duration: 5000 }
        );
      });
  }

  synchronizeIntegrator(order?: OrderAttributes) {
    const orders = order ? [order] : this.selection.selected;
    const orderIds: string[] = [];

    orders.forEach((o) => {
      const approvedItems =
        o.detail?.filter(
          (item) => item.statusId === StatusEnum.ORDER_APPROVED
        ) || [];

      if (approvedItems.length === 0) {
        this.snackBar.open(
          "No se puede sincronizar el pedido, al menos debe tener un material aprobado",
          "Cerrar",
          { duration: 3000 }
        );
        return;
      } else {
        /* approvedItems.forEach((item) => {
          orderIds.push(item.material._id.toString());
        }) */
        orderIds.push(o._id.toString());
      }
    });

    this.ordersListService
      .synchronizeOrdersOtherV2({
        returnRequestId: orderIds,
      })
      .subscribe({
        next: (res) => {
          this.snackBar.open("Registro sincronizado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.getList();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error sincronizando orders",
            "Cerrar",
            { duration: 5000 }
          );
        },
      });
  }

  getExtraStatusName(list: OrderExtraStatusAttributes[], type: string) {
    const status = list.find((i) => i.type == type);
    return status?.description || "-";
  }

  generateOrder(element) {
    if (!this.checkIfHasPermission(this.PERMISSIONS.CREATE, "No tiene permisos para generar pedido.")) {
      return;
    }

    let object = {
      quoteId: element._id,
    };
    this.router.navigate(["master", "sales", "order-generate"], {
      queryParams: object,
    });
  }

  onUpdateOrder(order: OrderAttributes): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS.UPDATE, "No tiene permisos para editar solicitudes de devolución.")) {
      return;
    }

    const dialogRef = this.dialog.open(UpdateOrderComponent, {
      panelClass: "form-modal",
      data: order,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.data) {
        const dataTemp = this.dataSource.data.slice();
        dataTemp.forEach((order) => {
          if (String(order._id) == String(result.data._id)) {
            order.address = result.data.address;
            order.expeditionCondition = result.data.expeditionCondition;
            order.note = result.data.note;
            order.statusERP = result.data.statusERP;
            order.statusId = result.data.statusId;
          }
        });
        this.dataSource.data = dataTemp;
        this.cdr.detectChanges();
      }
    });
  }

  onApproveOrRejectDetail(
    type: "A" | "R",
    order: OrderAttributes,
    orderDetail?: OrderDetailAttributes
  ) {
    if (type == "A") {
      this.onApproveDetail(order, orderDetail);
    } else {
      this.onRejectedDetail(order, orderDetail);
    }
  }

  onApproveDetail(order: OrderAttributes, orderDetail?: OrderDetailAttributes) {
    if (!this.checkIfHasPermission(this.PERMISSIONS.APPROVE_REJECT, "No tiene permisos para aprobar materiales.")) {
      return;
    }

    this.dialog
      .open(this.orderDetailConfirmDialog, {
        data: {
          title: orderDetail ? "Confirmar material" : "Confirmar materiales",
          message: orderDetail
            ? "¿Está seguro que desea aprobar el material?"
            : "¿Está seguro que desea aprobar los materiales?",
        },
        panelClass: "form-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.updateOrderDetail(
            order,
            StatusEnum.ORDER_APPROVED,
            result,
            orderDetail
          );
        }
      });
  }

  onRejectedDetail(
    order: OrderAttributes,
    orderDetail?: OrderDetailAttributes
  ) {
    if (!this.checkIfHasPermission(this.PERMISSIONS.APPROVE_REJECT, "No tiene permisos para rechazar materiales.")) {
      return;
    }

    const dialogRef = this.dialog.open(FormRejectComponent, {
      panelClass: "form-modal",
      data: {
        type: TypeRejectEnum.DEVOLUCION_PRODUCTO, //'SOLICITUD DEVOLUCION_PRODUCTO',
        orderDetail: orderDetail,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.updateOrderDetail(
          order,
          StatusEnum.ORDER_REJECTED,
          result,
          orderDetail
        );
      }
    });
  }

  updateOrderDetail(
    order: OrderAttributes,
    statusId: StatusEnum,
    result: any,
    orderDetail?: OrderDetailAttributes
  ) {
    if (orderDetail) {
      const detailIndex = order.detail.findIndex(
        (d) => d.position === orderDetail.position
      );

      if (detailIndex !== -1) {
        order.detail[detailIndex].statusId = statusId;
        order.detail[detailIndex].position = orderDetail.position;
        (order.detail[detailIndex]._id = orderDetail.material?._id),
          ((order.detail[detailIndex] as any).reasonForRejectionId =
            result.reasonRejectionId ?? null);

        this.updateAppReje(order, order);
      }
    } else {
      order.detail.forEach((detail) => {
        detail.statusId = statusId;
        detail.position = detail.position;
        (detail._id = detail.material?._id),
          ((detail as any).reasonForRejectionId =
            result.reasonRejectionId ?? null);
      });

      this.updateAppReje(order, order);
    }
  }

  isApproveDisabled(
    detail: any,
    detailsWithUnsavedChanges: Set<number>
  ): boolean {
    const isAlreadyApproved = detail.statusId === StatusEnum.ORDER_APPROVED;
    const hasNoBatches =
      detail.material?.batchControlActive &&
      (!detail.batches || detail.batches.length === 0);
    const hasInvalidQuantities =
      detail.material?.batchControlActive &&
      detail.batches?.length > 0 &&
      !this.checkBatchQuantities(detail);

    const hasUnsavedChanges = detailsWithUnsavedChanges.has(detail.position);

    return (
      isAlreadyApproved ||
      hasNoBatches ||
      hasInvalidQuantities ||
      hasUnsavedChanges
    );
  }

  checkBatchQuantities(detail: OrderDetailAttributes): boolean {
    // Obtener batches directamente de la base si están disponibles
    const baseDetail = this.getBaseDetail(detail.position);
    const batchesToCheck = baseDetail?.batches || detail.batches;

    if (!batchesToCheck?.length) return false;

    const hasInvalidLabels = batchesToCheck.some((batch) => {
      if (batch.labels?.length > 0) {
        const totalQuantity = batch.labels.reduce(
          (acc, label) => acc + (label.quantity || 0),
          0
        );
        return totalQuantity !== batch.quantity;
      }
      return false;
    });

    const totalBatchQuantity = batchesToCheck.reduce(
      (sum, batch) => sum + (batch.quantity || 0),
      0
    );
    const baseQuantity = baseDetail?.baseQuantity || detail.baseQuantity;

    return !hasInvalidLabels && totalBatchQuantity === baseQuantity;
  }

  private getBaseDetail(detailId: number): OrderDetailAttributes | undefined {
    return this.dataSource.data
      .flatMap((order) => order.detail)
      .find((d) => d.position === detailId);
  }

  // isApproveOrRejectDetailDisabled(type: 'A' | 'R'): boolean{
  //   const typeStatus = type == 'A' ? StatusEnum.ORDER_APPROVED : StatusEnum.ORDER_REJECTED;
  //   return this.selectedOrder.detail.every(item => item.statusId == typeStatus)
  // }

  isApproveOrRejectDetailDisabled(
    type: "A" | "R",
    detailsWithUnsavedChanges: Set<number>
  ): boolean {
    const typeStatus =
      type === "A" ? StatusEnum.ORDER_APPROVED : StatusEnum.ORDER_REJECTED;

    if (type === "R") {
      const allRejected = this.selectedOrder.detail.every(
        (item) => item.statusId === typeStatus
      );
      return allRejected;
    }

    return this.selectedOrder.detail.some((item) => {
      const hasUnsavedChanges = detailsWithUnsavedChanges.has(item.position);

      if (type === "A") {
        const isBatchInvalid =
          item.material?.batchControlActive &&
          (!item.batches?.length || !this.checkBatchQuantities(item));
        return (
          item.statusId === typeStatus || isBatchInvalid || hasUnsavedChanges
        );
      }
      return item.statusId === typeStatus || hasUnsavedChanges;
    });
  }

  onCancelOrder(
    order: OrderAttributes,
    orderDetail?: OrderDetailAttributes
  ): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS.UPDATE, "No tiene permisos para anular solicitudes de devolución.")) {
      return;
    }

    const dialogRef = this.dialog.open(CancelOrderComponent, {
      panelClass: "form-modal",
      data: {
        type: orderDetail ? "DETAIL" : "ORDER",
        order: order,
        orderDetail: orderDetail,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.data) {
        const dataTemp = this.dataSource.data.slice();
        if (
          this.selectedOrder &&
          String(this.selectedOrder._id) == String(order._id)
        ) {
          const detailTemp: OrderDetailAttributes[] = result.data.detail.map(
            (d) => {
              const detailFoundInLocal = this.selectedOrder.detail.find(
                (od) => od.position == d.position
              );
              d["stock"] = detailFoundInLocal
                ? detailFoundInLocal["stock"]
                : [];
              d["stockToValidate"] = detailFoundInLocal
                ? detailFoundInLocal["stockToValidate"]
                : undefined;
              return d;
            }
          );
          this.selectedOrder.detail = detailTemp;
          this.dataSourceDetail.data = this.selectedOrder.detail;
        }
        dataTemp.forEach((order) => {
          if (String(order._id) == String(result.data._id)) {
            order.subTotal = result.data.subTotal;
            order.totalDiscounts = result.data.totalDiscounts;
            order.totalSurcharges = result.data.totalSurcharges;
            order.subTotalBeforeTaxes = result.data.subTotalBeforeTaxes;
            order.totalTaxes = result.data.totalTaxes;
            order.total = result.data.total;
            order.detail = result.data.detail;
            order.reasonForRejection = result.data.reasonForRejection;
            order.statusERP = result.data.statusERP;
            order.statusId = result.data.statusId;
          }
        });
        this.dataSource.data = dataTemp;
        this.cdr.detectChanges();
      }
    });
  }

  onAddOrderDetail(order: OrderAttributes): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS.UPDATE, "No tiene permisos para modificar detalles de la solicitud.")) {
      return;
    }

    const dialogRef = this.dialog.open(AddOrderDetailComponent, {
      panelClass: "form-modal",
      data: {
        order,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.data) {
        const dataTemp = this.dataSource.data.slice();
        dataTemp.forEach((order) => {
          if (String(order._id) == String(result.data._id)) {
            order.subTotal = result.data.subTotal;
            order.totalDiscounts = result.data.totalDiscounts;
            order.totalSurcharges = result.data.totalSurcharges;
            order.subTotalBeforeTaxes = result.data.subTotalBeforeTaxes;
            order.totalTaxes = result.data.totalTaxes;
            order.total = result.data.total;
            order.detail = result.data.detail;
            order.statusERP = result.data.statusERP;
          }
        });
        this.dataSource.data = dataTemp;
        if (
          this.selectedOrder &&
          String(this.selectedOrder._id) == String(order._id)
        ) {
          this.selectedOrder.detail = result.data.detail || [];
          this.dataSourceDetail.data = this.selectedOrder.detail;
          this.getStock(
            this.selectedOrder,
            this.selectedOrder["warehousesToUpdate"]
          );
        }
        this.cdr.detectChanges();
      }
    });
  }

  onChangeWarehouseInOrderDetail(orderDetail: OrderDetailAttributes): void {
    orderDetail["stockToValidate"] = 0;
    if (orderDetail["stock"])
      orderDetail["stockToValidate"] = this.roundToX(
        orderDetail["stock"].find(
          (s: MaterialStockAttributes) =>
            String(s.warehouseId) == String(orderDetail.warehouse._id) &&
            String(s.unitOfMeasureId) ==
              String(orderDetail.soldUnitOfMeasure._id)
        )?.availableStock ?? 0,
        3
      );
    this.cdr.detectChanges();
  }

  onChangeSubTotalInOrderDetail(
    order: OrderAttributes,
    orderDetail: OrderDetailAttributes
  ): void {
    orderDetail["thereIsChanges"] = true;
    if (orderDetail.soldQuantity < 0) {
      orderDetail.soldQuantity = 0;
      this.snackBar.open("La cantidad no debe ser menor a cero.", "Cerrar", {
        duration: 3000,
      });
    }

    orderDetail.subTotal = orderDetail.unitPrice * orderDetail.soldQuantity;

    // Calcula descuentos
    orderDetail.totalDiscounts = 0;
    if (orderDetail.discounts && orderDetail.discounts.length > 0) {
      orderDetail.totalDiscounts = orderDetail.discounts.reduce(
        (acc, discount) => {
          switch (discount.type) {
            case "PERCENTAGE":
              return acc + (orderDetail.subTotal * discount.discount) / 100;
            case "AMOUNT":
              return acc + discount.discount;
            default:
              return acc;
          }
        },
        0
      );
    }

    orderDetail.subTotalBeforeTaxes =
      orderDetail.subTotal -
      orderDetail.totalDiscounts +
      orderDetail.totalSurcharges;

    // Calcula impuestos
    orderDetail.totalTaxes = 0;
    if (orderDetail.taxes && orderDetail.taxes.length > 0) {
      orderDetail.totalTaxes = orderDetail.taxes.reduce(
        (acc, tax) =>
          acc + (orderDetail.subTotalBeforeTaxes * tax.percentage) / 100,
        0
      );
    }

    orderDetail.total =
      orderDetail.subTotalBeforeTaxes + orderDetail.totalTaxes;
    this.calculateOrderTotals(order);
  }

  calculateOrderTotals(order: OrderAttributes): void {
    order.subTotal = 0;
    order.totalDiscounts = 0;
    order.totalSurcharges = 0;
    order.subTotalBeforeTaxes = 0;
    order.totalTaxes = 0;
    order.total = 0;

    order.detail.forEach((od) => {
      if (od.statusId == StatusEnum.ACTIVE) {
        order.subTotal += od.subTotal;
        order.totalDiscounts += od.totalDiscounts;
        order.totalSurcharges += od.totalSurcharges;
        order.subTotalBeforeTaxes += od.subTotalBeforeTaxes;
        order.totalTaxes += od.totalTaxes;
        order.total += od.total;
      }
    });
    this.cdr.detectChanges();
  }

  onChangeQuantityInOrderDetail(
    order: OrderAttributes,
    orderDetail: OrderDetailAttributes
  ): void {
    orderDetail["thereIsChanges"] = true;
    if (
      order.class["makesStockValidation"] &&
      orderDetail["stockToValidate"] &&
      orderDetail.soldQuantity > orderDetail["stockToValidate"]
    ) {
      orderDetail.soldQuantity = orderDetail["stockToValidate"];
      this.snackBar.open(
        "La cantidad no debe ser mayor al disponible.",
        "Cerrar",
        { duration: 3000 }
      );
    }
    this.onChangeSubTotalInOrderDetail(order, orderDetail);
  }

  onChangePriceInOrderDetail(
    order: OrderAttributes,
    orderDetail: OrderDetailAttributes
  ): void {
    orderDetail["thereIsChanges"] = true;
    if (orderDetail.unitPrice < 0) {
      orderDetail.unitPrice = 0;
      this.snackBar.open("El precio no debe ser menor a cero.", "Cerrar", {
        duration: 3000,
      });
    }
    this.onChangeSubTotalInOrderDetail(order, orderDetail);
  }

  openOrderDetailUpdateConfirmation(
    order: OrderAttributes,
    orderDetail: OrderDetailAttributes
  ): void {
    if (orderDetail["thereIsChanges"])
      this.dialog
        .open(this.orderDetailUpdateConfirmationDialog, {
          data: null,
          panelClass: "form-modal",
          disableClose: true,
        })
        .afterClosed()
        .subscribe((result) => {
          if (result) this.onSaveOrderDetailUpdate(order, orderDetail);
        });
    else orderDetail["isEditMode"] = false;
    this.cdr.detectChanges();
  }

  onSaveOrderDetailUpdate(
    order: OrderAttributes,
    orderDetail: OrderDetailAttributes
  ): void {
    const dataToUpdate: IUpdateOrder = {
      detail: [
        {
          position: orderDetail.position,
          warehouseId: orderDetail.warehouse
            ? String(orderDetail.warehouse._id)
            : null,
          soldQuantity: orderDetail.soldQuantity,
          unitPrice: orderDetail.unitPrice,
        },
      ],
    };

    this.updateOrderService
      .updateOrder(String(order._id), dataToUpdate)
      .subscribe({
        next: (result) => {
          this.snackBar.open("Detalle actualizado con éxito.", "Cerrar", {
            duration: 3000,
          });
          orderDetail["isEditMode"] = false;
          orderDetail["thereIsChanges"] = false;
          if (result && result.data) {
            const dataTemp = this.dataSource.data.slice();
            if (
              this.selectedOrder &&
              String(this.selectedOrder._id) == String(order._id)
            ) {
              const detailTemp: OrderDetailAttributes[] =
                result.data.detail.map((d) => {
                  const detailFoundInLocal = this.selectedOrder.detail.find(
                    (od) => od.position == d.position
                  );
                  d["stock"] = detailFoundInLocal
                    ? detailFoundInLocal["stock"]
                    : [];
                  d["stockToValidate"] = detailFoundInLocal
                    ? detailFoundInLocal["stockToValidate"]
                    : undefined;
                  return d;
                });
              this.selectedOrder.detail = detailTemp;
              this.dataSourceDetail.data = this.selectedOrder.detail;
            }
            dataTemp.forEach((order) => {
              if (String(order._id) == String(result.data._id)) {
                order.subTotal = result.data.subTotal;
                order.totalDiscounts = result.data.totalDiscounts;
                order.totalSurcharges = result.data.totalSurcharges;
                order.subTotalBeforeTaxes = result.data.subTotalBeforeTaxes;
                order.totalTaxes = result.data.totalTaxes;
                order.total = result.data.total;
                order.detail = result.data.detail;
                order.statusERP = result.data.statusERP;
              }
            });
            this.dataSource.data = dataTemp;
            this.cdr.detectChanges();
          }
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el detalle.",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  async getStock(order: OrderAttributes, warehouses: WarehouseAttributes[]) {
    let dataToSend = {
      materialsIds: order.detail
        .filter((od) => od.statusId == StatusEnum.ACTIVE)
        .map((d) => String(d.material._id)),
      unitMeasureIds: [],
      warehouseIds: warehouses.map((w) => String(w._id)),
    };
    const stock: MaterialStockAttributes[] = await this.ordersCreationService
      .fetchStock(dataToSend)
      .toPromise()
      .then((res) => res.data[0].data);

    order.detail.forEach((od) => {
      od["stock"] = stock.filter(
        (s) => String(s.materialId) == String(od.material._id)
      );
      od["stockToValidate"] = this.roundToX(
        od["stock"].find(
          (s: MaterialStockAttributes) =>
            String(s.warehouseId) == String(od.warehouse._id) &&
            String(s.unitOfMeasureId) == String(od.soldUnitOfMeasure._id)
        )?.availableStock ?? 0,
        3
      );
    });
    if (
      this.selectedOrder &&
      String(this.selectedOrder._id) == String(order._id)
    )
      this.dataSourceDetail.data = this.selectedOrder.detail || [];
    this.cdr.detectChanges();
  }

  async getDocumentClass(order: OrderAttributes) {
    const documentClass: DocumentClassAttributes =
      await this.documentClassService
        .findOne(String(order.class._id))
        .toPromise()
        .then((res) => res.data);
    if (documentClass) order.class = documentClass;
    this.cdr.detectChanges();
  }

  roundToX(value: number, decimals: number) {
    return parseFloat(value.toFixed(decimals));
  }

  openLogModal(element: OrderAttributes) {
    if (!this.checkIfHasPermission(this.PERMISSIONS.VIEW_LOGS, "No tiene permisos para ver los logs.")) {
      return;
    }

    let dataToModal = {
      documentIdentifier: element.serial,
    };
    this.dialog.open(LogModalComponent, {
      width: "90%",
      data: dataToModal,
      disableClose: true,
    });
  }

  openAuditLog(element: OrderAttributes): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS.VIEW_AUDIT_LOG, "No tiene permisos para ver el log de modificaciones.")) {
      return;
    }

    this.auditLogViewerService.open({
      documentIdentifiers: { _id: element._id?.toString() },
      entityName: element.serial,
      collectionName: AUDIT_LOG_COLLECTIONS.ORDER,
    });
  }

  validateColumnErp(order: OrderAttributes) {
    return validateIsAction([order], this.documentClassesList, "SYNC");
  }

  validateDataToSynchronize(order: OrderAttributes) {
    return validateOrdersByAction([order], this.documentClassesList, "SYNC");
  }

  validateDataToEdit(order: OrderAttributes) {
    return validateOrdersByAction([order], this.documentClassesList, "EDIT");
  }

  validateDataToCopy(order: OrderAttributes) {
    return validateOrdersByAction([order], this.documentClassesList, "COPY");
  }

  validateDataToDivide(order: OrderAttributes) {
    return (
      validateOrdersByAction([order], this.documentClassesList, "DIVIDE") &&
      order?.sourceTransactions.length == 0
    );
  }

  validateDataToGenerateOrder(order: OrderAttributes) {
    return validateOrdersByAction([order], this.documentClassesList, "QUOTE");

    //Primera regla
    let ruleStatusId: boolean = false;
    if (environment.projectName == "PORTUGAL") {
      ruleStatusId = order?.statusId == StatusEnum.ORDER_APPROVED;
    } else {
      ruleStatusId =
        order?.statusId == StatusEnum.ACTIVE ||
        order?.statusId == StatusEnum.ORDER_IN_PROGRESS ||
        order?.statusId == StatusEnum.ORDER_APPROVED;
    }

    let ruleERPIntegrated: boolean = false;
    ruleERPIntegrated =
      !this.isErpIntegrated || order?.externalKeys?.code != null;

    return ruleStatusId && ruleERPIntegrated;
  }

  validateDataToAppOrRejected(order: OrderAttributes) {
    return (
      validateOrdersByAction([order], this.documentClassesList, "APPROVE") ||
      validateOrdersByAction(
        [order],
        this.documentClassesList,
        "APPROVE_GENERATE_NEXT"
      ) ||
      validateOrdersByAction([order], this.documentClassesList, "REJECT")
    );
  }

  //aprobar/rechazar
  openModal(element): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS.APPROVE_REJECT, "No tiene permisos para aprobar o rechazar solicitudes de devolución.")) {
      return;
    }

    const filterPending = element.detail.filter(
      (item) => item.statusId == StatusEnum.ACTIVE
    );
    if (filterPending.length > 0) {
      this.snackBar.open(
        "No se puede aprobar/rechazar un pedido con detalle pendiente",
        "Cerrar",
        { duration: 3000 }
      );
      return;
    }

    const filterApproved = element.detail.filter(
      (item) => item.statusId == StatusEnum.ORDER_APPROVED
    );
    if (filterApproved.length == 0) {
      this.snackBar.open(
        "No se puede aprobar el pedido, al menos debe tener un material aprobado",
        "Cerrar",
        { duration: 3000 }
      );
      return;
    }

    const dialogRef = this.dialog.open(FormApproRejectComponent, {
      width: "800px",
      data: {
        element: element,
        requeriment: {
          approve:
            filterApproved.length == 0
              ? false
              : validateOrdersByAction(
                  [element],
                  this.documentClassesList,
                  "APPROVE"
                ),
          approve_generate: validateOrdersByAction(
            [element],
            this.documentClassesList,
            "APPROVE_GENERATE_NEXT"
          ),
          reject: validateOrdersByAction(
            [element],
            this.documentClassesList,
            "REJECT"
          ),
        },
        type: TypeRejectEnum.DEVOLUCION_PRODUCTO,
      }, //'DEVOLUCION'
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === undefined || result == "Close") {
      } else {
        if (result) {
          if (result.approve_document) {
            if (!result.documentClassId) {
              this.snackBar.open("Sin documento de clase", "Cerrar", {
                duration: 3000,
              });
              return;
            }

            let sendOrder = {
              documentClassId: result.documentClassId,
              subApplicationId: environment.subApplicationId,
            };
            this.updateAppDocument(element, sendOrder);
          } else {
            let sendOrder: IUpdateOrder = {
              reasonForRejectionId: result.reasonRejectionId ?? null,
              statusId: result.approve ? StatusEnum.ORDER_APPROVED : StatusEnum.INACTIVE,
            };

            this.updateAppReje(element, sendOrder);
          }
        }
      }
    });
  }

  updateAppReje(element, result) {
    this.ordersListService.updateV2(element._id, result).subscribe({
      next: () => {
        this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
          duration: 3000,
        });
        const dataTemp = this.dataSource.data.slice();
        this.dataSource.data = dataTemp;
        if (
          this.selectedOrder &&
          String(this.selectedOrder._id) == String(element._id)
        ) {
          this.selectedOrder.detail = result.detail || [];
          this.dataSourceDetail.data = this.selectedOrder.detail;
        }
        this.getList();
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al actualizar el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  updateAppDocument(element, result) {
    this.ordersListService.approveNextDocument(element._id, result).subscribe({
      next: () => {
        this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.getList();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al actualizar el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  cloneOrder(element: OrderAttributes, type: string) {
    // the template passes lowercase, so normalise before comparing
    const normalizedCloneType = (type ?? "").toLowerCase() === "divide" ? "divide" : "copy";

    if (normalizedCloneType === "copy" && !this.checkIfHasPermission(this.PERMISSIONS.COPY, "No tiene permisos para copiar solicitudes de devolución.")) {
      return;
    }

    if (normalizedCloneType === "divide" && !this.checkIfHasPermission(this.PERMISSIONS.SPLIT, "No tiene permisos para dividir solicitudes de devolución.")) {
      return;
    }

    //type: 'copy', 'divide'
    const dialogRef = this.dialog.open(SelectOrderDetailComponent, {
      data: { order: element, type: type },
      disableClose: true,
      width: "90%",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.data) {
      }
    });
  }

  onExportButtonPressed() {
    if (!this.checkIfHasPermission(this.PERMISSIONS.EXPORT, "No tiene permisos para exportar solicitudes de devolución.")) {
      return;
    }

    if (!this.salesReturnListExport.canStartTask()) return;

    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: {
        title: SALES_RETURN_LIST_TITLE,
      },
    });

    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.salesReturnListExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex
        );
      }
    });
  }

  openApprovalUser(element) {
    const dialogRef = this.dialog.open(ModalApprovalUserComponent, {
      width: "90%",
      data: element,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === undefined || result == "Close") {
      } else {
      }
    });
  }

  // openImageCarousel(images: any[]) {
  //   const imageLinks = images.map((image) => image.link);
  //   const dialogRef = this.dialog.open(ImageCarouselComponent, {
  //     panelClass: "form-modal",
  //     disableClose: true,
  //     data: { images: imageLinks },
  //   });

  //   dialogRef.afterClosed().subscribe((result) => {
  //   });
  // }

  openImageCarousel(images: any[], position: number, type: string) {
    const imageLinks = images.map((image) => image.link);
    const dialogRef = this.dialog.open(ImageCarouselComponent, {
      panelClass: "form-modal",
      disableClose: true,
      data: {
        images: imageLinks,
        position,
        type: this.type,
        order: this.selectedOrder,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == "Success") {
        this.getList(); // Actualiza datos
        const updatedOrder = this.dataSource.data.find(
          (item) => item._id === this.selectedOrder._id
        );
        this.cdr.detectChanges();
        if (updatedOrder) {
          this.closeDetails();
          setTimeout(() => this.toggleDetails(updatedOrder), 0);
        }
      }
    });
  }

  canAddImages(order: OrderAttributes, detail: OrderDetailAttributes): boolean {
    const hasEvidences = (detail?.evidences?.length || 0) > 0;
    return this.validateDataToEdit(order) || hasEvidences;
  }

  openBatchesDetail(
    order: OrderAttributes,
    orderDetail: OrderDetailAttributes
  ) {
    const originalBatches = JSON.parse(JSON.stringify(orderDetail.batches));
    const dialogRef = this.dialog.open(BatchesDetailComponent, {
      width: "90%",
      data: {
        order: order,
        data: orderDetail,
        type: "normal",
        isEdit: this.validateDataToAppOrRejected(order) ? true : false,
        isChangeCostBatch: true,
        updatePermission: this.PERMISSIONS.UPDATE,
      },
      disableClose: true,
    });

    dialogRef
      .afterClosed()
      .subscribe((response: { saved?: boolean; detailId?: number }) => {
        if (response?.saved === false) {
          const detailIndex = order.detail.findIndex(
            (d) => d.position === response.detailId
          );
          if (detailIndex > -1) {
            order.detail[detailIndex].batches = originalBatches;
          }
          if (
            !this.checkBatchQuantities({
              ...orderDetail,
              batches: originalBatches,
            })
          ) {
            this.detailsWithUnsavedChanges.add(response.detailId!);
          }
        } else if (response?.saved === true) {
          this.detailsWithUnsavedChanges.delete(response.detailId!);
          this.getList();
        }
      });
  }

  ShowBatchWarning(detail: any, unsavedChanges: Set<number>): boolean {
    const hasBatchControl = detail.material?.batchControlActive;
    const hasUnsavedChanges = unsavedChanges.has(detail.position);

    return (
      hasBatchControl &&
      (!detail.batches?.length ||
        !this.checkBatchQuantities(detail) ||
        hasUnsavedChanges)
    );
  }

  getBatchWarningTooltip(detail: any, unsavedChanges: Set<string>): string {
    if (unsavedChanges.has(detail.material._id.toString())) {
      return "¡Tienes cambios no guardados en este lote!";
    }
    if (!detail.batches?.length) {
      return "¡Faltan lotes asignados!";
    }
    if (!this.checkBatchQuantities(detail)) {
      return "¡Las cantidades de lotes no coinciden con el total!";
    }
    return "";
  }

  ngOnDestroy() {
    this.searchSubscription.unsubscribe();
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  goToTravel(element: OrderAttributes) {
    if (element.trip?.id) {
      const queryParams = { tripId: element.trip.id };
      const urlTree = this.router.createUrlTree(
        ["monitor", "principal-screen"],
        { queryParams }
      );
      const absoluteUrl =
        window.location.origin + this.router.serializeUrl(urlTree);
      window.open(absoluteUrl, "_blank");
    }
  }

  fetchSoldToName = (soldtoId: string): string => {
    const foundSoldTo = this.soldToList.find(
      (soldTo) => soldTo.id === soldtoId
    );
    if (foundSoldTo) {
      return foundSoldTo.name;
    }
    return "";
  };

  fetchShipToName = (shipToId: string): string => {
    const foundShipTo = this.shipToList.find(
      (shipTo) => shipTo.id === shipToId
    );
    if (foundShipTo) {
      return foundShipTo.name;
    }
    return "";
  };

  isThereOrderNextTransactions(element: any): boolean {
    return (
      Array.isArray(element?.nextTransactions) &&
      element.nextTransactions.some(
        (t) => t?.type?.code === DocumentTypeEnum.DEVOLUCION_DE_PRODUCTO
      )
    );
  }

  goToReturnList(element: OrderAttributes) {
    if (element?.serial && Array.isArray(element?.nextTransactions)) {
      const orderIds = element.nextTransactions
        .filter(
          (t) => t?.type?.code === DocumentTypeEnum.DEVOLUCION_DE_PRODUCTO
        )
        .map((t) => t.serial)
        .toString();

      if (orderIds.length > 0) {
        const queryParams = {
          orderIds: orderIds,
        };
        const urlTree = this.router.createUrlTree(
          ["master", "sales", "return-list"],
          { queryParams }
        );
        const absoluteUrl =
          window.location.origin + this.router.serializeUrl(urlTree);
        window.open(absoluteUrl, "_blank");
      }
    }
  }

  hasTrip(element: OrderAttributes): boolean {
    return !!element?.trip?.id;
  }

  getTooltip(el: OrderAttributes): string {
    const rutaCode =
      el?.subRoute?.externalKeys?.code ?? el?.subRoute?.model ?? "-";
    const rutaName = el?.subRoute?.name ?? "-";
    const user = el?.user?.user_login?.username ?? "-";

    const person = el?.responsibleBusinessPartner?.personNumber
      ? `${el.responsibleBusinessPartner.personNumber} - `
      : "";
    const bpCode = el?.responsibleBusinessPartner?.externalKeys?.code ?? "";
    const bpName = el?.responsibleBusinessPartner?.name ?? "-";

    return [
      `Ruta: ${rutaCode} | ${rutaName}`,
      `Usuario: ${user}`,
      `Responsable: ${person}${bpCode} ${bpName}`.trim(),
    ].join("\n");
  }

  checkIfHasPermission(permission: string, errorMessage?: string): boolean {
    const hasPermission = this.permissionService.has(permission);

    if (!hasPermission && errorMessage) {
      this.handlerMessage.error({ message: errorMessage });
    }

    return hasPermission;
  }
}